<template>
  <b-row>
    <b-col cols="12">
      <karma-category-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaCategoryEditForm from './KarmaCategoryEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaCategoryEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
